export enum UploadStatus {
    added = 'added',
    completed = 'completed',
    error = 'error',
    removed = 'removed',
    success = 'success',
}
